import {useFileDownload} from '@domain/file-download'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {useUpmPlantContext} from '@hconnect/upm'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {Link} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {fetchDownloadSalesForecastExcelTemplate} from '../../hooks'

export const DownloadSalesForecastExcelTemplate: React.FC = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const downloadFile = useFileDownload()

  const handleDownloadTemplate = async () => {
    try {
      const [file, headers] = await fetchDownloadSalesForecastExcelTemplate(plantCode)
      downloadFile(file, headers)
      spawnSuccessToast(t('success.downloadExcelTemplateSuccess'))
    } catch {
      spawnErrorToast(t('error.downloadSalesForecastTemplate'))
    }
  }

  return (
    <Link
      onClick={() => void handleDownloadTemplate()}
      {...dataTestId('download_sales_forecast_template')}
    >
      {t('demand.downloadExcelTemplate')}
    </Link>
  )
}
